import { useState } from "react"
import { useShallow } from "zustand/react/shallow"
import { Flex } from "antd"

// components
import { Select, TextInput, InputNumber } from "components-design-system"
import CharCounter from "components/CharCounter/CharCounter"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const SubjectJoinReason = ({ arm, reason, onChangeReason, onDeleteReason }) => {
  const { readOnly } = useAuthoringViewStore(useShallow((state) => ({ readOnly: state.readOnly })))

  const [showDelete, setShowDelete] = useState(false)
  let label = "Other reason"
  if (reason.reason === "Late recruitment") label = "Late recruitment reason"

  let showReasonDetail = reason.reason === "Late recruitment" || reason.reason === "Other (please specify)"

  return (
    <div
      className="flex flex-col"
      style={{
        position: "relative",
        gap: 8,
        borderBottom: "1px solid lightgrey",
        paddingBottom: "16px",
        marginBottom: 8,
      }}
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}
    >
      <Select
        label="Reason"
        options={["Late recruitment", "Transferred in from other group/arm", "Other (please specify)"]}
        value={reason.reason}
        onChange={(e) => onChangeReason("reason", e)}
      />
      {showReasonDetail && (
        <Flex vertical>
          <TextInput
            label={label}
            readOnly={readOnly}
            value={reason.reason_detail}
            onChange={(e) => onChangeReason("reason_detail", e.target.value)}
          />

          <div className="char-counter-container">
            <CharCounter
              value={reason.reason_detail}
              maxChars={50}
            />
          </div>
        </Flex>
      )}
      <InputNumber
        label={"Subjects"}
        readOnly={readOnly}
        value={reason.subjects}
        onChange={(val) => onChangeReason("subjects", val)}
      />
      {showDelete && (
        <i
          onClick={onDeleteReason}
          className="fal fa-trash-alt trash-icon cursor-pointer"
          style={{
            position: "absolute",
            bottom: 22,
            right: 0,
          }}
        />
      )}
    </div>
  )
}

export default SubjectJoinReason
